<div class="modal-header">
  <h4 class="modal-title pull-left">{{title}}</h4>
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="onCancelClick()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="mb-3 row">
    <label class="col-12 col-form-label">
      {{message}}
    </label>
  </div>
</div>
<div>
  @if (dialogType === dialogTypeMap.message) {
    <div class="modal-footer">
      <button type="button" class="btn btn-primary default-width" (click)="bsModalRef.hide()">Ok</button>
    </div>
  }
  @if (dialogType === dialogTypeMap.confirm) {
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary default-width" (click)="onCancelClick()">Cancel</button>
      <button type="button" class="btn btn-primary default-width" (click)="onConfirmClick()">Confirm</button>
    </div>
  }

  @if (dialogType === dialogTypeMap.yesNo) {
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary default-width" (click)="onNoClick()">No</button>
      <button type="button" class="btn btn-primary default-width" (click)="onYesClick()">Yes</button>
    </div>
  }
</div>
